import { styled } from "styled-components";
import { CardType } from "./types";

export const CardContainer = styled.div<CardType>`
  display: grid;
  grid-template-columns: repeat(auto-fit, 320px); /* Fixed width for each card */
  gap: 20px;
  // border: 1px solid red;
  // padding: 20px;
  justify-content: center; /* Center the cards in the container */
  width: 100%;

   @media (max-width: 400px) {
    grid-template-columns: 1fr; /* Single column layout */
    gap: 10px; /* Smaller gap for tight spaces */
    padding: 0;
  }
`;

export const Card = styled.div<CardType>`
  position: relative;
  width: ${({$width})=> $width || "100%"};
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Ensure content is spaced */
  align-items: center;
  height: 400px; /* Fixed height for uniformity */
  border: 1px solid ${({ theme }) => theme.circularIconBg};
  border-radius: 10px;
  padding: ${({ $padding }) => $padding || "10px"};
  font-weight: 600;
  box-sizing: border-box;

  .imgContent {
    width: 100%;
    height: 85%; /* Fixed height for images */
    object-fit: cover; /* Ensure proportional scaling and cropping */
    border-radius: 10px 10px 0 0;
  }

  .content {
    height: 15%; /* Consistent height for content */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-weight: 300;
    text-align: center; /* Ensure text is centered */
    padding: 10px; /* Add padding for spacing */
    box-sizing: border-box; /* Include padding in total height */
  }

  .moreOpttionsBtn {
    position: absolute;
    top: 13px;
    right: 12px;
    background: ${({ theme }) => theme.text};
    color: ${({ theme }) => theme.circularIconTextBg};
    border: 1px solid ${({ theme }) => theme.text};
    border-radius: 50%;
    width: 26px;
    height: 26px;

    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 22px;
    
    &:hover,
    &:focus {
      background: ${({ theme }) => theme.circularIconTextBg};
      color: ${({ theme }) => theme.text};
      border: 1px solid ${({ theme }) => theme.text};
    }
  }
`;

